const shipment = {
  shipmentMana: 'Shipping Request',
  shipmentListPage: 'Shipping Order',
  add: 'Add',
  edit: 'Edit',
  delete: 'Delete',
  detail: 'Details',
  export: 'Export',
  import: 'Import',
  search: 'Search',
  reset: 'Reset',
  confirm: 'Confirm',
  cancel: 'Cancel',
  cancelOk: 'Cancelled Successfully',
  cancelFAil: 'Cancel Failed',
  confirmCancel: 'Are you sure you want to cancel shipping order {{no}}?',
  orderNumber: 'Order No.',
  customerName: 'Customer Name',
  status: 'Status',
  sourceType: 'Source Type',
  consignee: 'Consignee',
  consigneeAddress: 'Consignee Address',
  consigneePhone: 'Consignee Phone',
  destinationCountry: 'Destination Country',
  tradeTerms: 'Trade Terms',
  paymentTerms: 'Payment Terms',
  planShipDate: 'Planned Shipment Date',
  actualShipDate: 'Actual Shipment Date',
  deliveredAt: 'Delivery Time',
  remark: 'Remarks',
  items: 'Items',
  createTime: 'Creation Time',
  operation: 'Operation',
  productCode: 'Product Code',
  productName: 'Product Name',
  count: 'Quantity',
  saleOrderCount: 'Sales Order Quantity',
  amount: 'Amount',
  uom: 'UoM',
  unitPrice: 'Unit Price',
  currency: 'Currency',
  itemRemark: 'Item Remarks',
  plKeyword: 'Please enter order No. or customer name',
  shipMethod: 'Shipping Method',
  shipLogistics: 'Carrier',
  shipEvent: 'Logistics Tracking',
  saleOrder: 'Sales Order',
  saleOrderItem: 'Sales Order Item',
  selectOrder: 'Select Order',
  selectOrderItem: 'Select Order Item',
  noProduct: 'No Products',
  customerShipAddress: 'Select Consignee Address',
  plCustomerName: 'Please enter customer name',
  plConsignee: 'Please enter consignee',
  plConsigneePhone: 'Please enter consignee phone',
  plConsigneeAddress: 'Please enter consignee address',
  plRemark: 'Please enter remarks',
  plTradeTerms: 'Please enter trade terms',
  plPaymentTerms: 'Please enter payment terms',
  plCurrency: 'Please enter currency',
  plCarrier: 'Please enter carrier',
  addPackOrder: 'Add Sorting List',
  yes: 'Yes',
  no: 'No',
  number: 'Shipping Order No.',
  trackingNo: 'Tracking No.',
  blNo: 'B/L No.',
  vesselVoyage: 'Vessel/Voyage',
  containerNo: 'Container No.',
  shipped: 'Shipped',
  pending: 'Pending',
  shippedAt: 'Shipped At',
  freightCost: 'Freight Cost',
  addLogistics: 'Add Logistics',
  editLogistics: 'Edit Logistics',
  plTrackingNo: 'Please enter tracking No.',
  plBlNo: 'Please enter B/L No.',
  plVesselVoyage: 'Please enter vessel/voyage/flight',
  plContainerNo: 'Please enter container No.',
  plFreightCost: 'Please enter freight cost',
  addError: 'Add Failed',
  saveFail: 'Save Failed',
  saveOk: 'Save Successful',
  addSuccess: 'Add Successful',
  freightCurrency: 'Freight Currency',
  noPackOrder: 'No Sorting List',
  shipmentNoPack: 'Shipping order has no sorting list, cannot add logistics',
  packNoShipment: 'Sorting list has no shipping order, cannot add logistics',
  getPackErr: "Failed to get sorting list!",
  logistics: "Logistics Order",
  eventTime: 'Event Time',
  location: 'Location',
  description: 'Description',
  shipEvents: 'Logistics Tracking',
  plLocation: 'Please enter location',
  plDescription: 'Please enter description',
  addEvent: 'Add Tracking',
  doShip: 'Ship',
  shipOk: 'Shipped Successfully',
  shipFail: 'Shipment Failed',
  viewLogistics: 'View Logistics',
  creator: 'Creator',
  viewPackOrder: 'View Sorting List',
  viewShipmentOrder: 'View Shipment Order',
  repeated: 'Duplicate items ignored',
  addShipOutPl: "Please generate the shipping outbound order first!",
  hasLogis: "This shipping order already has logistics",
  plSelShip: "Please select shipping orders",
  plSelShipErr: "Only shipping orders generated from the same sorting order can be selected",
  exportErr: "Export failed",
};

export default shipment;
